import React, { useContext, useEffect, useRef, useState } from "react";
import DommusBarraTitulo from "../../components/DommusBarraTitulo";
import ItemBarraTitulo from "../../components/DommusBarraTitulo/ItemBarraTitulo";
import RegistroAtendimento from "./RegistroAtendimento";
import { Col, Row, Container, Tooltip, OverlayTrigger, Badge } from "react-bootstrap";
import DetalheAtendimento from "./DetalheAtendimento";
import DetalheProcesso from "./DetalheProcesso";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./style.scss";
import {
    faArrowRight,
  faBroomBall,
  faList,
  faPlusCircle,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import ModalDommus from "../../components/Modal";
import ModalNovoAtendimento from "./ModalNovoAtendimento";
import { trackPromise } from "react-promise-tracker";
import caAPI from "../../services/caAPI";
import AtendimentoService from "../../services/AtendimentoService";
import { WebSocketContext } from "../../contexts/WebSocketContext";
import { AtendentesContext } from "../../contexts/AtendentesContext";
import { successToast } from "../../components/DommusToast";
import { AtendimentoContext } from "../../contexts/AtendimentoContext";
import { VoipContext } from "../../contexts/VoipContext";
import FiltrarAtendimentos from "./FiltrarAtendimentos";
import AtendimentoIntervaloDatasPicker from "./AtendimentoIntervaloDatasPicker";
import { celularMask } from "../../components/InputTextMask";
import NotificationDommus from "../../helpers/NotificationsHelper";
import { errorToast, infoToast } from "../../components/DommusToast";
import BaciaAtendimentoWrapper from "./BaciaAtendimentoWrapper";
import { ItensAtalhoContext } from "../../contexts/ItensAtalhosContext";
import RegistroChamadasPerdidas from "../../components/Anotacoes/ChamadasPerdidas";
import urlHelper from "../../helpers/UrlHelper";
import {BrowserView, MobileView, isDesktop, isMobile} from 'react-device-detect';
import Swal from "sweetalert2";
import { AtendentesSection } from "./AtendentesSection";
import { DommusPlaceholderDetalhesAtendimento } from "../../components/DommusPlaceholderDetalhesAtendimento";
import { MeioComunicacaoListaPrincipal } from "./MeioComunicacaoListaPrincipal";
import { FiltrosLaterais } from "./FiltrosLaterais";
import { DndContext, MouseSensor, useSensor, useSensors } from "@dnd-kit/core";
import { Icon } from "@iconify/react";
import { useHistory } from "react-router-dom";
import { ListaFiltrosCentraisAtendimento } from "./ListaFiltrosCentraisAtendimento";
import { cachearContexto } from "../../helpers/CachearContexto";


export default function PortalCliente(props) {
  const [openModalNovoAtendimento, setOpenModalNovoAtendimento] = useState(false);
  const [countFiltros, setCountFiltros] = useState(0);
  const [filter, setFilter] = useState(false);
  const [salvarFiltros, setSalvarFiltros] = useState(null);
  const {recarregarItensAtalho} = useContext(ItensAtalhoContext);
  const [atendimentoUrl, setAtendimentoUrl] = useState(null)
  const [dataInicio, setDataInicio] = useState()
  const [dataFim, setDataFim] = useState()
  const history = useHistory();
  const mouseSensor = useSensor(MouseSensor, {
    activationConstraint: {
      delay: 100,
      tolerance: 3,
    },
  });

  const sensors = useSensors(mouseSensor);

  const {
    listaAtendimentos,
    setListaAtendimentos,
    setAtendimentoAtivo,
    atendimentoAtivo,
    openFiltros,
    setOpenFiltros,
    filtro,
    buscandoAtendimentos,
    loadingMensagens,
    checkExisteIdEmLista,
    atualizarTotaisAtendimentos,
    openListaTiposAtendimentos,
    setOpenListaTiposAtendimentos,
    isOpenInformacoesAtendimento,
    setIsOpenInformacoesAtendimento,
    setIdDragActive,
    funcoesListaAtendimentosRef,
    listaContatosOrigem,
    setListaContatosOrigem,
  } = useContext(AtendimentoContext);

  const atendimentoAtivoRef = useRef(atendimentoAtivo);
  useEffect(() => {
    atendimentoAtivoRef.current = atendimentoAtivo;
  }, [atendimentoAtivo]);

  const { recarregarListaAtendentes, validarUsuarioAtualAtendePorAtendimento } = useContext(AtendentesContext);
  // Os handlers de websocket abaixo são registrados uma única vez (deps [channel]). Para não
  // ficarem presos ao filtro e aos atendentes gerenciados da primeira renderização, validam
  // sempre pela versão mais recente do validador.
  const validarUsuarioAtualAtendePorAtendimentoRef = useRef(validarUsuarioAtualAtendePorAtendimento);
  validarUsuarioAtualAtendePorAtendimentoRef.current = validarUsuarioAtualAtendePorAtendimento;

  const { channel } = useContext(WebSocketContext);
  const { inCallStatus, solicitarPermissaoMicrofone, atendimentoInCall } = useContext(VoipContext);

  useEffect(()=>{
    cachearContexto(listaContatosOrigem, setListaContatosOrigem, caAPI.contato_origem.list);
  },[])

  const abrirAtendimento = (atendimento) => {
    if(atendimentoAtivo?.id == atendimento.id) {
      return
    }
    if ((!(inCallStatus) || atendimentoInCall?.id == atendimento?.id) && !(loadingMensagens)) {
      const indiceAtendimento = listaAtendimentos.findIndex(
        (el) => Number(el.id) === Number(atendimento.id)
      );
      setAtendimentoAtivo(atendimento)
      trackPromise(caAPI.atendimento.find(atendimento.id).then(res => {
        const novoAtendimento = Object.assign({}, res.data);
        novoAtendimento.conteudos = res.data.conteudos
        const novaLista = listaAtendimentos.slice();
        novoAtendimento.msg_nao_lidas = 0;
        if (indiceAtendimento > -1) {
          novaLista.splice(indiceAtendimento, 1, novoAtendimento);
        }
        novoAtendimento.hasMore = res.data.hasMore || false;
        setAtendimentoAtivo(novoAtendimento);
        setListaAtendimentos(novaLista);
        atualizarTotaisAtendimentos()
      }), 'busca-atendimento-selecionado');

      recarregarItensAtalho();

    }else{
      errorToast.fire({ text: "Em ligação." });
    }
  };

  useEffect(() => {
    solicitarPermissoesNavegador()
  }, [])

  function solicitarPermissoesNavegador() {
    solicitarPermissaoMicrofone()
  }

  useEffect(() => {
    const idAtendimento = urlHelper.obterParametroDaUrl('idAtendimento')
    if(idAtendimento && listaAtendimentos.length && !atendimentoUrl) {
      const atendimentoAbrir = listaAtendimentos.find(atendimento => atendimento.id === Number(idAtendimento))
      if(atendimentoAbrir) {
        setAtendimentoAtivo(atendimentoAbrir)
        setAtendimentoUrl(atendimentoAbrir)
        abrirAtendimento(atendimentoAbrir);
      }
    }
  }, [listaAtendimentos])

  useEffect(() => {
    channel.unbind("nova-mensagem");
    channel.unbind("atendimento-assumido");
    channel.unbind("atendimento-arquivado");
    channel.unbind("atendimento-finalizado");

    if(listaAtendimentos){
      channel.bind("nova-mensagem", function (data) {
        if(data.id_atendimento && data.id_contato_origem){
          let atendimentoTeste = {
            id: data.id_atendimento,
            origem:{
              id_contato_origem: data.id_contato_origem
            },
            atendente: data.id_atendente
          }
          if (validarUsuarioAtualAtendePorAtendimentoRef.current(atendimentoTeste)) {
            caAPI.atendimento.findWithoutReading(data.id_atendimento).then((response)=>{
              let atendimento = response.data;
              const atendimentoAtivoAtual = atendimentoAtivoRef.current;
              const { handleAdiconaLista: adicionarNaLista, verificaAtendimentoValidoNaListaComFiltros: validarComFiltros } = funcoesListaAtendimentosRef.current;
              if (
                data &&
                data.id_atendimento &&
                (!atendimentoAtivoAtual ||
                  (atendimentoAtivoAtual &&
                    atendimentoAtivoAtual.id &&
                    Number(atendimentoAtivoAtual.id) !== Number(data.id_atendimento)))
              ) {
                if(validarComFiltros(atendimento)) {
                  verificaMeioComunicacaoNotificacao(data, atendimento)
                  handleAddBadget(atendimento);
                }
              }
              adicionarNaLista(atendimento);
            }).catch((erro)=>{
              Swal.fire({
                  titleText: "Erro",
                  text: "Houve um problema ao buscar atendimento " + erro,
                  icon: 'error'
              });
            });
          }
        }
      });

      channel.bind("atendimento-assumido", function (data) {
        if(data.atendimento && data.id_contato_origem){
          let atendimentoTeste = {
            id: data.atendimento,
            origem:{
              id_contato_origem: data.id_contato_origem
            },
            atendente: data.id_atendente
          }

          if(validarUsuarioAtualAtendePorAtendimentoRef.current(atendimentoTeste)) {
            caAPI.atendimento.findWithoutReading(data.atendimento).then((response)=>{
              let atendimento = response.data;
              const atendimentoAtivoAtual = atendimentoAtivoRef.current;
              let idUsuario = Number(caAPI.getLocalState("idUsuario"));
              if (
                atendimento &&
                atendimento.id &&
                (atendimentoAtivoAtual &&
                    atendimentoAtivoAtual.id &&
                    Number(atendimentoAtivoAtual.id) === Number(atendimento.id)) &&
                ( Number(atendimento.atendente) !== idUsuario ) && atendimento.atendente
              ) {
                infoToast.fire({text:"Atendimento já respondido"});
                setAtendimentoAtivo(null);
              }
              funcoesListaAtendimentosRef.current.handleAdiconaLista(atendimento);
            }).catch((erro)=>{
              Swal.fire({
                titleText: "Erro",
                text: "Houve um problema ao buscar atendimento " + erro,
                icon: 'error'
              });
            });
          } else {
            const atendimentoAtivoAtual = atendimentoAtivoRef.current;
            if((atendimentoAtivoAtual?.id && atendimentoTeste?.id && atendimentoTeste?.atendente) &&
              (Number(atendimentoAtivoAtual.id) === Number(atendimentoTeste.id))) {
              infoToast.fire({text:"Atendimento já respondido"});
              setAtendimentoAtivo(null);
              funcoesListaAtendimentosRef.current.handleRemoveLista(atendimentoTeste)
            }
          }
        }
      });

      // channel.bind("atendimento-arquivado", function (data) {
      //   if(data?.id_atendimento && checkExisteIdEmLista(data?.id_atendimento)){
      //     if(atendimentoAtivo && (atendimentoAtivo.id == data.id_atendimento)){
      //       infoToast.fire({text:"Atendimento arquivado"});
      //       setAtendimentoAtivo(null);
      //     }
      //     handleRemoveLista({id: data.id_atendimento});

      //   }
      // });

      channel.bind("atendimento-finalizado", function (data) {
        if(data?.id_atendimento && checkExisteIdEmLista(data?.id_atendimento)){
          caAPI.atendimento.find(data.id_atendimento).then(res => {
            const atendimentoAtivoAtual = atendimentoAtivoRef.current;
            if(atendimentoAtivoAtual && (atendimentoAtivoAtual.id == data.id_atendimento)){
              infoToast.fire({text:"Atendimento finalizado"});
              if(res.data?.id) {
                setAtendimentoAtivo(res.data)
              }
            }
          }).catch(e => {
              console.log("Erro ao buscar atendimento finalizado." + data.id_atendimento);
              return;
          })
        }
      });
    }
    return () => {
      channel.unbind("nova-mensagem");
      channel.unbind("atendimento-assumido");
      channel.unbind("atendimento-arquivado");
      channel.unbind("atendimento-finalizado");

    }
  }, [channel]);

  useEffect(() => {
    setFilter(JSON.parse(caAPI.getLocalState('filtrosCount')))
  }, [filtro])

  function verificaMeioComunicacaoNotificacao(atendimento){
    if(atendimento?.meio_comunicacao === 4){
      NotificationDommus.showNotification(`Você recebeu um novo email de ${atendimento?.contato_destino}`, 'Novo E-mail')
    }else if(atendimento?.meio_comunicacao === 2){
      NotificationDommus.showNotification(`${celularMask(atendimento?.contato_destino)} disse: ${atendimento?.ultima_msg?.conteudo.length > 70 ? atendimento?.ultima_msg?.conteudo.substring(0, 70) + '...' : atendimento?.ultima_msg?.conteudo}`, 'Nova Mensagem')
      NotificationDommus.beepWhatsapp();
    }else{
      NotificationDommus.showNotification(`Você recebeu uma nova mensagem de ${atendimento?.contato_destino} .`, 'Nova Mensagem');
    }
  }

  function handleAddBadget(data) {
    successToast.fire(
      '<span style="color:#FFFF"> mensagem recebida no atendimento #' +
      data.id +
      " (" +
      ( data.msg_nao_lidas || 0 ) +
      ") mensagens não lidas </span>"
    );
  }

  function handleServicesCleanByCommunicationType(){
      const cleanedListAtendimentos = listaAtendimentos.filter(atendimento => {
        if(filter.meio_comunicacao.includes(atendimento.meio_comunicacao.id)){
            return atendimento;
        }
      })

      setListaAtendimentos(cleanedListAtendimentos)
  }

  useEffect(() => {
    let countLet = 0;
    if (typeof filtro === 'object') {
      for (let attr in filtro) {
        if ((Array.isArray(filtro[attr]) && filtro[attr].length) || (!Array.isArray(filtro[attr]) && filtro[attr])) {
          countLet += 1;
        }
      }
    }
    setCountFiltros(countLet);
  }, [filtro, setCountFiltros]);

  function alteraTipoAtendimentoDoAtendimento(idAtendimento, idTipoAtendimento, area=""){
    const payload = {
      tipo_atendimento: idTipoAtendimento
    }
    trackPromise(caAPI.atendimento.update(payload, idAtendimento).then((response)=>{
      setListaAtendimentos((current) => current.map((item)=>{
        return item.id === response?.data?.id ? response?.data : item;
      }))
      atualizarTotaisAtendimentos();
    }).catch((error)=>{
      errorToast.fire({ text: "Erro ao atribuir o tipo de atendimento." });
    }), area)
  }

  function adicionarMarcadorAtendimento(idAtendimento, idMarcador, area=""){
    const payload = {
     id_tag : idMarcador,
    }
    trackPromise(caAPI.tags.adicionarTagAtendimento(idAtendimento, payload).then((response)=>{
      setListaAtendimentos((current) => current.map((item)=>{
        if(item.id === Number(idAtendimento)){
          item.tags?.push(response?.data?.tag);
        }
        return item;
      }))
      atualizarTotaisAtendimentos();
    }).catch((error)=>{
      errorToast.fire({ text: "Erro ao atribuir o marcador." });
    }), area)

  }

  function handleEndDrag(event){
    const {active, over } = event;
    const [atendimento, idAtendimento] = active.id.split('-'); 
    if(over && over.id){
      const [tipo, id] = over.id.split('-'); 
      switch(tipo){
        case 'tipo_atendimento':
          alteraTipoAtendimentoDoAtendimento(Number(idAtendimento), Number(id), active.id);
          break;
        case 'marcador':
          adicionarMarcadorAtendimento(Number(idAtendimento), Number(id), active.id);
          break;
        default:
          break;
      }
    }else{
      const atendimentoSelecionado = listaAtendimentos.find((item) => item.id === Number(idAtendimento));
      if(atendimentoSelecionado?.id !== atendimentoAtivo?.id){
        abrirAtendimento(atendimentoSelecionado)
      }
    }
    setIdDragActive(null);
  }

  function handleStartDrag(event){
    setIdDragActive(event.active.id)
  }

  const tipoDataFiltroAplicado = filtro?.data_criacao_inicio ? 2 : 1

  function handleAbrirFiltros() {
    if(buscandoAtendimentos) {
      return
    }
    setOpenFiltros(true)
  }

  return (
    <>
    <Container fluid className={`${(isMobile && "restringir-height-container") || ""}`}>
      <BrowserView>
        <DommusBarraTitulo>
          <ItemBarraTitulo classe="titulo-ca">Central de Atendimento</ItemBarraTitulo>
          <ItemBarraTitulo classe="periodo">
            <Badge className="badge-identifica-data-tela-inicial mr-3" variant="info">{tipoDataFiltroAplicado == 2 ? "Data de Criação" : "Última Atualização"}</Badge>
            <div>
              <AtendimentoIntervaloDatasPicker tipoBusca={tipoDataFiltroAplicado}></AtendimentoIntervaloDatasPicker>
            </div>
          </ItemBarraTitulo>
          <ItemBarraTitulo classe={`btn ${buscandoAtendimentos ? "filtro-bloqueado" : ""}`} onClick={handleAbrirFiltros}>
            <OverlayTrigger
              key="buttonPesquisa"
              placement="top"
              overlay={
                <Tooltip id={`tooltip-Pesquisa`}>
                  Pesquisar
                </Tooltip>
              }
            >
              <FontAwesomeIcon icon={faSearch} color="#265d9c" />
            </OverlayTrigger>
            {countFiltros >= 0 ? <div className="indicativoFiltro2">{countFiltros}</div> : <></>}
          </ItemBarraTitulo>
          <ItemBarraTitulo
            classe="btn"
            onClick={() => {
              recarregarListaAtendentes();
              setOpenModalNovoAtendimento(true);
            }}
          >
            <OverlayTrigger
              key="buttonNovo"
              placement="top"
              overlay={
                <Tooltip id={`tooltip-Novo`}>
                  Iniciar atendimento
                </Tooltip>
              }
            >
              <FontAwesomeIcon icon={faPlusCircle} color="#4caf50" />
            </OverlayTrigger>
          </ItemBarraTitulo>

          <OverlayTrigger key={"btn-clean"}
              placement="top"
              overlay={
                <Tooltip id={`tooltip-itens-enviados`}>
                  Abrir tela de itens enviados
                </Tooltip>
              }>
                <ItemBarraTitulo  classe="btn"
                  onClick={() =>{
                    history.push('/itens-enviados')
                  }}>
                  <Icon icon="mingcute:mail-send-line" color="#de8903" width="1.1rem"/>
                </ItemBarraTitulo>
              </OverlayTrigger>
          <BaciaAtendimentoWrapper />
        </DommusBarraTitulo>
      </BrowserView>
      {
        !atendimentoAtivo && <MobileView className="mobile-view-barra-titulo">
          <DommusBarraTitulo>
            <ItemBarraTitulo>Central de Atendimento</ItemBarraTitulo>
            <div className="subitens-section-mobile">
              <button className="btn-lista-tipos-atendimentos-mobile" onClick={()=>{setOpenListaTiposAtendimentos((current) => !current)}}>
                <FontAwesomeIcon icon={faList}/>
              </button>
            </div>
          </DommusBarraTitulo>
        </MobileView>
      }
      { (isDesktop || (isMobile && !atendimentoAtivo)) ? (
        <Row>
          <DndContext 
            onDragEnd={handleEndDrag} 
            onDragStart={handleStartDrag}
            sensors={sensors}
          >
          {openListaTiposAtendimentos && isDesktop && 
              <FiltrosLaterais/>
          }
          <Col sm={openListaTiposAtendimentos ? 10 : 12}>
            <Row>
              <Col sm={10} md={4} xs className="pr-0">
                <div className="subitens-section">
                  <BrowserView>
                    <OverlayTrigger
                        key="btn-lista-tipos-atendimentos"
                        placement="right"
                        overlay={
                            <Tooltip id={`tooltip-tipos-atendimento`}>
                               Filtros Laterais 
                            </Tooltip>
                        }
                    >
                      <button className="btn-lista-tipos-atendimentos" onClick={()=>{setOpenListaTiposAtendimentos((current) => !current)}}>
                        <FontAwesomeIcon icon={faList}/>
                      </button>
                    </OverlayTrigger>
                  </BrowserView>
                  <MeioComunicacaoListaPrincipal/>
                </div>
              </Col>
              {isDesktop && 
                <Col xs sm={1} md={5}>
                  <ListaFiltrosCentraisAtendimento/>
                </Col>
              }
              <Col xs sm={1} md={3}>
                <AtendentesSection/>
              </Col>
            </Row>
            {isMobile && (
              <Row className="mx-2 my-2">
                <ListaFiltrosCentraisAtendimento/>
              </Row>
            )}
            <Row className="atendimentos-section">
                <Col sm={4} className="lista-atendimentos">
                  <RegistroAtendimento
                    abrirAtendimento={abrirAtendimento}
                    atendimentoAtivoId={atendimentoAtivo && atendimentoAtivo.id}
                  />
                </Col>
                {isDesktop &&
                  <>
                    <Col sm={isOpenInformacoesAtendimento ? 4 : 8} className="detalhes-atendimentos" style={{borderTopRightRadius: isOpenInformacoesAtendimento ? "0px" : "10px"}}>
                      {atendimentoAtivo ? (
                        <DetalheAtendimento callbackVoltar={() => setAtendimentoAtivo(null)}>
                          {atendimentoAtivo && (
                            <RegistroChamadasPerdidas atendimento={atendimentoAtivo} />
                          )}
                        </DetalheAtendimento>
                     ) : 
                        <DommusPlaceholderDetalhesAtendimento/>
                    }
                    </Col>
                    {atendimentoAtivo && isOpenInformacoesAtendimento && (
                      <Col sm={4} className="informacoes-atendimento-section">
                        <DetalheProcesso atendimento={atendimentoAtivo}/>
                      </Col>
                    )}
                  </>
                }
            </Row>
          </Col>
          </DndContext>
        </Row>
      ) : (
            <DetalheAtendimento callbackVoltar={() => setAtendimentoAtivo(null)}/>
          )
      }
      <ModalDommus
        titulo="Novo Atendimento"
        open={openModalNovoAtendimento}
        close={() => setOpenModalNovoAtendimento(false)}
      >
        <ModalNovoAtendimento
          setOpenModalNovoAtendimento={setOpenModalNovoAtendimento}
        />
      </ModalDommus>
      <ModalDommus
        className="modalFiltros"
        open={openFiltros}
        size={"lg"}
        close={() => {
          setOpenFiltros(false);
        }}
        titulo={"Filtrar chamados"}
      >
        <FiltrarAtendimentos setSalvarFiltros={setSalvarFiltros} setDataInicio={setDataInicio} setDataFim={setDataFim}/>
      </ModalDommus>
    </Container>
      <>
        {isMobile && openListaTiposAtendimentos && <FiltrosLaterais/>}
        {isMobile && atendimentoAtivo && isOpenInformacoesAtendimento && (
          <div className="informacoes-adicionais-mobile-section">
            <div className="header-info-adicionais">
              <span>Informações</span>
              <FontAwesomeIcon 
                className="btn-retornar"
                icon={faArrowRight} 
                onClick={() => {
                  setIsOpenInformacoesAtendimento(false)
                }}
              />
            </div>
            <RegistroChamadasPerdidas atendimento={atendimentoAtivo} />
            <div className="informacoes-atendimento-section">
              <DetalheProcesso atendimento={atendimentoAtivo}/>
            </div>
          </div>
        )}
      </>
    {
        isMobile && <div class="dommus-mobile-navigation">
        <div class="dommus-mobile-navigation-wrapper">
          <ul class="navigation">
            <li>
              <a className={buscandoAtendimentos ? "filtro-bloqueado" : ""} onClick={handleAbrirFiltros}>
                <OverlayTrigger
                  key="buttonPesquisa"
                  placement="top"
                  overlay={
                    <Tooltip id={'tooltip-Pesquisa'}>
                      Pesquisar
                    </Tooltip>
                  }
                >
                  <FontAwesomeIcon icon={faSearch} />
                </OverlayTrigger>
                {countFiltros >= 0 ? <div className="indicativoFiltro2">{countFiltros}</div> : <></>}
              </a>
            </li>
            <li class="btn-open-navigation">
              <a
                onClick={() => {
                  recarregarListaAtendentes();
                  setOpenModalNovoAtendimento(true);
                }}
              >
                <OverlayTrigger
                  key="buttonNovo"
                  placement="top"
                  overlay={
                    <Tooltip id={'tooltip-Novo'}>
                      Iniciar atendimento
                    </Tooltip>
                  }
                >
                  <FontAwesomeIcon icon={faPlusCircle} />
                </OverlayTrigger>
              </a>
            </li>
            <li>
              <BaciaAtendimentoWrapper />
            </li>
          </ul>
        </div>
      </div>
    }
    </>
  );
}
